<template>
  <div class="tender-documents">
    <div class="tender-documents__header">
      <div class="title">{{ $t('tender-details.documents') }} ({{ tender.documents.length }})</div>
    </div>
    <template v-if="hasDocuments">
      <div v-if="hasMainDocuments">
        <div class="subtitle">
          <span v-if="hasAddenda"> {{ $t('tender-details.documents') }} ({{ mainDocuments.length }}) </span>
        </div>

        <BaseInformationalDocument v-for="(document, index) in mainDocuments" :key="index" :document="document" />
      </div>
      <div v-if="hasAddenda">
        <div class="subtitle">{{ $t('tender-details.addenda') }} ({{ addenda.length }})</div>
        <BaseInformationalDocument v-for="(addenda, index) in addenda" :key="index" :document="addenda" />
      </div>
    </template>
  </div>
</template>

<script>
import BaseInformationalDocument from '@/components/base/BaseInformationalDocument';

export default {
  name: 'TenderDocuments',
  components: {
    BaseInformationalDocument,
  },
  props: {
    tender: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  computed: {
    mainDocuments() {
      return this.tender.documents.filter((doc) => !doc.addendum);
    },
    addenda() {
      return this.tender.documents.filter((doc) => doc.addendum);
    },
    hasMainDocuments() {
      return this.mainDocuments.length > 0;
    },
    hasAddenda() {
      return this.addenda.length > 0;
    },
    hasDocuments() {
      return this.tender.documents.length > 0;
    },
  },
};
</script>

<style lang="scss">
.tender-documents {
  padding: 2rem;
  margin-bottom: 1rem;
  background: $color-white;
  border-radius: $border-radius-root;

  &__empty {
    padding-top: 16px;
    color: $color-neutral;
  }

  @media screen and (max-width: 1080px) {
    margin-right: 0px;
    margin-bottom: 1rem;
  }
}
</style>
